// Nsibidi glyph registry + renderer.
// Fetches /data/nsibidi.json once, exposes window.Nsibidi.render(id, size).

const state = {
  glyphs: null,
  ready: null
};

export async function load() {
  if (state.ready) return state.ready;
  state.ready = (async () => {
    let json;
    if (window.NSIBIDI_DATA) {
      json = window.NSIBIDI_DATA;
    } else if (window.NSIBIDI_URL) {
      const res = await fetch(window.NSIBIDI_URL);
      json = await res.json();
    } else {
      json = { glyphs: [] };
    }
    state.glyphs = Object.fromEntries(json.glyphs.map(g => [g.id, g]));
    return state.glyphs;
  })();
  return state.ready;
}

export async function render(id, size = 28, className = 'nsibidi-icon') {
  const glyphs = await load();
  const g = glyphs[id];
  if (!g) return '';
  return `<svg class="${className}" viewBox="0 0 100 100" width="${size}" height="${size}" fill="none" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${g.svg}</svg>`;
}

export async function renderInto(el, id, size) {
  const html = await render(id, size);
  el.innerHTML = html;
}

export function allIds() {
  return state.glyphs ? Object.keys(state.glyphs) : [];
}

window.Nsibidi = { render, renderInto, load };

// Hydrate any page-level placeholders on first load
document.addEventListener('DOMContentLoaded', async () => {
  const slots = document.querySelectorAll('[data-nsibidi]');
  if (!slots.length) return;
  await load();
  for (const slot of slots) {
    const id = slot.dataset.nsibidi;
    const size = parseInt(slot.dataset.size || '28', 10);
    slot.innerHTML = await render(id, size);
  }
});
